export const PERMISSIONS_API_APPS_NAMES = [
  'menumanager',
  'availability',
  'refund',
  'devices',
  'manager',
  'data',
  'datanext',
  'canopy',
  'loyalty',
  'access',
]
